import { libelleLiberation, libelleSexeAge, libelleNature } from '@/utils/portail-sorties'

// PORT-001 : confirmation de « Sortie constatée ». Le parent envoie la demande ;
// la fenêtre ne peut pas être fermée pendant l'enregistrement.
export default {
    name: 'confirmer-sortie-modal',
    props: {
        patient: { type: Object, default: null },
        is_saving: { type: Boolean, default: false },
        peut_confirmer: { type: Boolean, default: false },
        message_erreur: { type: String, default: '' }
    },
    data() {
        // Armée seulement quand la fenêtre est entièrement affichée (événement shown) : un double appui
        // sur « Sortie constatée » ne peut pas toucher « Confirmer la sortie » pendant l'ouverture.
        return { pret: false }
    },
    computed: {
        est_ouverte() { return !!this.patient },
        sexe_age() { return this.patient ? libelleSexeAge(this.patient) : '' },
        liberation() { return this.patient ? libelleLiberation(this.patient) : '' },
        nature() { return this.patient ? libelleNature(this.patient.nature) : '' },
        bouton_actif() { return !!this.patient && this.pret && this.peut_confirmer && !this.is_saving }
    },
    watch: {
        patient(nouveau, ancien) {
            if (!nouveau || !ancien || nouveau.patient_id !== ancien.patient_id) this.pret = false
        }
    },
    methods: {
        affichee() {
            if (this.patient) this.pret = true
        },
        // Fermeture par l'utilisateur (Échap, croix) bloquée pendant l'envoi ; la fermeture pilotée par le parent passe.
        avant_fermeture(event) {
            if (this.is_saving && event && event.trigger && typeof event.preventDefault === 'function') event.preventDefault()
        },
        confirmer() {
            if (!this.bouton_actif) return
            this.$emit('confirmer')
        },
        annuler() {
            if (this.is_saving) return
            this.$emit('annuler')
        }
    }
}
